import {
  DollarSign,
  TrendingUp,
  GraduationCap,
  MapPin,
  Calendar,
  Trophy,
} from "lucide-react";

const ITEMS = [
  {
    icon: DollarSign,
    title: "100% Commission Model",
    body: "Keep what you close. No quotas to clip your wings — your effort directly fuels your paycheck.",
  },
  {
    icon: TrendingUp,
    title: "Uncapped Earning Potential",
    body: "Top reps clear six figures. We don't cap commissions, we celebrate them.",
  },
  {
    icon: GraduationCap,
    title: "Field Training Provided",
    body: "Two-week ride-along with a top closer. Learn the pitch, the door, and the close.",
  },
  {
    icon: MapPin,
    title: "Nationwide Territories",
    body: "Live anywhere. Sell everywhere. Active across multiple states with new markets opening monthly.",
  },
  {
    icon: Calendar,
    title: "Flexible Schedule",
    body: "Set your own hours. Work full-time or as a side hustle — your performance, your pace.",
  },
  {
    icon: Trophy,
    title: "Bi-Weekly Commission",
    body: "Get paid Bi-weekly for your work.",
  },
];

export const Benefits = () => {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-blue-600 mb-4">
            Why Knockwave
          </p>
          <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-bold text-slate-900">
            We didn't build a sales job.
            <br />
            We built a path to wealth.
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
            Knockwave reps don't just sell internet plans. They build careers,
            buy homes, and retire parents. Here's what makes the difference.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {ITEMS.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`benefit-card-${idx}`}
                className="group bg-white p-8 md:p-10 hover:bg-slate-50 transition-colors duration-300"
              >
                <div className="w-12 h-12 bg-slate-900 text-white flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-slate-900 tracking-tight mb-3">
                  {item.title}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed">
                  {item.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
